<div class="p-6">
  <form [formGroup]="updateForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
    <!-- Cover Image Upload -->
    <div class="flex flex-col gap-4">
      <label class="font-medium">{{ 'projectEdit.updates.coverImage' | translate }}</label>

      <!-- File Upload -->
      <p-fileUpload mode="basic" name="updateCoverImage" accept="image/*" [maxFileSize]="5000000"
        (onSelect)="onCoverImageSelect($event)" [auto]="true"
        [chooseLabel]="'projectEdit.updates.chooseCoverImage' | translate" chooseIcon="pi pi-image" class="w-fit" />

      <!-- Image Preview -->
      @if (coverImagePreview) {
      <div class="relative w-fit">
        <img [src]="
            coverImagePreview
              ? (coverImagePreview.startsWith('data:') || coverImagePreview.startsWith('http') || coverImagePreview.startsWith('blob:')
                  ? coverImagePreview
                  : (coverImagePreview | adminImageSrc: projectId : {}))
              : null
          " alt="Update cover preview" class="w-full max-w-md h-48 object-cover rounded-lg border" />
        <p-button icon="pi pi-times" [rounded]="true" [outlined]="true" (onClick)="removeCoverImage()"
          class="absolute top-2 right-2" [title]="'projectEdit.updates.removeCoverImage' | translate" />
      </div>
      }
    </div>

    <!-- Title Field -->
    <div class="flex flex-col gap-2">
      <label for="updateTitle" class="font-medium">{{
        'projectEdit.updates.updateTitle' | translate
        }}</label>
      <input id="updateTitle" type="text" pInputText [formControl]="titleControl"
        [placeholder]="'projectEdit.updates.titlePlaceholder' | translate" class="w-full" />
      @if (titleControl.invalid && titleControl.touched) {
      <p-message severity="error">
        {{ getTitleErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Publish Date Field -->
    <div class="flex flex-col gap-2">
      <label for="updatePublishDate" class="font-medium">{{
        'projectEdit.updates.publishDate' | translate
        }}</label>
      <p-datePicker id="updatePublishDate" [formControl]="publishDateControl" [showTime]="false" dateFormat="dd/mm/yy"
        [placeholder]="'projectEdit.updates.publishDatePlaceholder' | translate" class="w-full" />
      @if (publishDateControl.invalid && publishDateControl.touched) {
      <p-message severity="error">
        {{ getPublishDateErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Text Field -->
    <div class="flex flex-col gap-2">
      <label for="updateText" class="font-medium">{{
        'projectEdit.updates.text' | translate
        }}</label>
      <textarea id="updateText" [formControl]="textControl"
        [placeholder]="'projectEdit.updates.textPlaceholder' | translate" rows="6"
        class="w-full border border-gray-300 rounded px-3 py-2"></textarea>
      @if (textControl.invalid && textControl.touched) {
      <p-message severity="error">
        {{ getTextErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Action Buttons -->
    <div class="flex flex-col md:flex-row gap-4 mt-6">
      <p-button type="submit" [label]="
          isEdit
            ? ('projectEdit.updates.updateUpdate' | translate)
            : ('projectEdit.updates.addUpdate' | translate)
        " [disabled]="updateForm.invalid" />

      <p-button type="button" [label]="'projectEdit.cancel' | translate" severity="secondary" [outlined]="true"
        (onClick)="onCancel()" />
    </div>
  </form>
</div>
